import React from 'react';
import type { WeddingPropType } from '../types';

type SealSectionProps = {
  topSeal?: boolean;
  wedding: WeddingPropType;
};

function SealSection({ wedding, topSeal }: SealSectionProps): JSX.Element {
  return (
    <div className={['homepage-seal', topSeal ? 'top-seal' : 'bottom-seal'].join(' ')}>
      <div className="seal-section">
        <span className="name-1">
          {wedding.owner_first_name && (
            <span className="initial-1">{wedding.owner_first_name[0]}</span>
          )}
          {wedding.owner_last_name && (
            <span className="initial-2">{wedding.owner_last_name[0]}</span>
          )}
        </span>
        {wedding.owner_first_name && wedding.partner_first_name && (
          <span>
            <span className="amp">&amp;</span>
            <span className="and">and</span>
            <span className="plus">+</span>
          </span>
        )}
        <span className="name-2">
          {wedding.partner_first_name && (
            <span className="initial-1">{wedding.partner_first_name[0]}</span>
          )}
          {wedding.partner_last_name && (
            <span className="initial-2">{wedding.partner_last_name[0]}</span>
          )}
        </span>
      </div>
    </div>
  );
}

export default SealSection;
